export default {
  list: [],
  loginAsUser: {}
}